import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsHootsuiteComponent } from './simple-icons-hootsuite.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsHootsuiteComponent ],
    exports:      [ SimpleIconsHootsuiteComponent ],
    bootstrap:    []
})
export class SimpleIconsHootsuiteModule {}
